module.exports = __webpack_public_path__ + "fonts/Roboto-500.90d16760.woff2";